(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@alife/cn-ui"));
	else if(typeof define === 'function' && define.amd)
		define(["@alife/cn-ui"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@alife/cn-ui")) : factory(root["CNUI"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return 